<template>
    <v-menu offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small class="mr-n2">
                <v-icon left>mdi-tune-variant</v-icon>
                <span>Filters</span>
            </v-btn>
        </template>
        <v-list nav dense>
            <v-sheet v-for="poolType in displayedPoolTypes" :key="poolType.value" rounded class="py-2 px-4 my-1">
                <v-switch
                    inset
                    dense
                    hide-details
                    class="pa-0 ma-0"
                    :input-value="isSelected(poolType.value)"
                    @change="setTypeSelection(poolType.value, $event)">
                    <template v-slot:label>
                        <div class="d-flex align-center">
                            <v-icon left small color="primary">{{ poolType.icon }}</v-icon>
                            <span>{{ poolType.label }}</span>
                        </div>
                    </template>
                </v-switch>
            </v-sheet>
        </v-list>
    </v-menu>
</template>

<script>
import { RESOURCE_POOL_FILTER_TYPES, RESOURCE_POOL_FILTER_TYPE_OPTIONS } from '@/modules/user/components/resourcePoolMeta'

export default {
    name: 'PoolTypeFilterMenu',
    props: {
        value: {
            type: Array,
            default: null
        },
        availableTypes: {
            type: Array,
            default: () => RESOURCE_POOL_FILTER_TYPES.slice()
        }
    },
    computed: {
        availablePoolTypes() {
            return RESOURCE_POOL_FILTER_TYPES.filter(type => this.availableTypes.includes(type))
        },
        displayedPoolTypes() {
            return RESOURCE_POOL_FILTER_TYPE_OPTIONS.filter(type => this.availablePoolTypes.includes(type.value))
        },
        selectedPoolTypes() {
            if (!Array.isArray(this.value)) {
                return this.availablePoolTypes.slice()
            }

            const validPoolTypes = this.value.filter(type => this.availablePoolTypes.includes(type))
            return Array.from(new Set(validPoolTypes))
        }
    },
    methods: {
        isSelected(poolType) {
            return this.selectedPoolTypes.includes(poolType)
        },
        setTypeSelection(poolType, selected) {
            const nextSelectedPoolTypes = [...this.selectedPoolTypes]

            if (selected) {
                if (!nextSelectedPoolTypes.includes(poolType)) {
                    nextSelectedPoolTypes.push(poolType)
                }
            } else {
                const typeIndex = nextSelectedPoolTypes.indexOf(poolType)
                if (typeIndex !== -1) {
                    nextSelectedPoolTypes.splice(typeIndex, 1)
                }
            }

            this.$emit('input', nextSelectedPoolTypes)
        }
    }
}
</script>
